import React from 'react';
import { QuestionPassStateId } from '../../../learnware/LearnwareEnums';
import { QuestionPassState } from '../QuestionPassState';
export class QuestionPassState_Passed3 extends QuestionPassState {
    id = QuestionPassStateId.Passed3;
    name = (React.createElement("span", null,
        React.createElement("i", { className: "fas fa-globe" }),
        " Weltklasse - 3 Mal richtig"));
    color = 'success';
    orderInProgressbar = 1;
    isDefaultFiltered = true;
}
